import type {SummaryT} from '@freckle/school/ts/common/models/summary'
import {useQueryParamAsString, useQueryParamAsNum} from '@freckle/school/ts/hooks/use-params'
import type {IdentityProviderOrNoneT} from '@freckle/school/ts/manage-teachers/api-helpers/filters'
import {parseDefaultIdpsFromQueryParam} from '@freckle/school/ts/manage-teachers/api-helpers/filters'
import type {CourseFilterTagT} from './constants'
import {COURSE_FILTER_TAG} from './constants'
import {CourseTabContainer} from './course-tab'
import type {Props as CourseTabProps} from './course-tab'

export type CourseTabFilteringT = {
  tag: CourseFilterTagT
  sisIdExists?: boolean
  student?: {
    id: number
    name: string
  }
  courseName?: string
  teacherName?: string
  studentGrade?: string
  identityProviders: Array<IdentityProviderOrNoneT>
}

type Props = {
  summary: SummaryT
} & CourseTabProps

export function CourseTabHandler(props: Props) {
  const {tableParams, summary, ...rest} = props

  // SisId filter
  const mSisIdExists = useQueryParamAsString('sisIdExists')
  const sisIdExists =
    mSisIdExists === 'true'
      ? {sisIdExists: true}
      : mSisIdExists === 'false'
        ? {sisIdExists: false}
        : {}

  // StudentId Filter
  const mStudentId = useQueryParamAsNum('studentId')
  const mStudentName = useQueryParamAsString('studentName')
  const student =
    mStudentId !== null && mStudentName !== null
      ? {student: {id: mStudentId, name: decodeURIComponent(mStudentName)}}
      : {}

  // Table filters
  const courseName = useQueryParamAsString('courseName')
  const courseNameObj = courseName !== null && courseName !== '' ? {courseName} : {}

  const teacherName = useQueryParamAsString('teacherName')
  const teacherNameObj = teacherName !== null && teacherName !== '' ? {teacherName} : {}

  const studentGrade = useQueryParamAsString('studentGrade')
  const studentGradeObj = studentGrade !== null && studentGrade !== '' ? {studentGrade} : {}

  const identityProviders = parseDefaultIdpsFromQueryParam(
    useQueryParamAsString('identityProviders'),
    {
      tag: 'for-course',
      ...summary
    },
    {tag: 'summary'}
  )

  const tableParamsWithFilter = {
    ...tableParams,
    additionalFilters: {
      tag: COURSE_FILTER_TAG,
      ...sisIdExists,
      ...student,
      ...courseNameObj,
      ...teacherNameObj,
      ...studentGradeObj,
      identityProviders
    }
  }

  return <CourseTabContainer tableParams={tableParamsWithFilter} summary={summary} {...rest} />
}
